import {EditPaymentRequestBody} from '@dms/api/sales';
import {useGetCurrentBranch} from '@dms/shared';

import {FormValuesType} from '../types/FormValuesType';

export const useGetSubmitBody = () => {
  const {data: branchData} = useGetCurrentBranch();

  const getPaymentBody = (data: FormValuesType): EditPaymentRequestBody => {
    const comment = data.note ?? '';
    const exchangeRate = data.exchangeRate?.toString() || null;
    const rawTenantBankAccount = branchData?.billingInformation?.bankAccounts.find(
      (item) => item.accountNumber === data.tenantBankAccount
    );
    const tenantBankAccount = rawTenantBankAccount
      ? {
          accountName: rawTenantBankAccount.accountName ?? '',
          accountNumber: rawTenantBankAccount.accountNumber ?? '',
          bankName: rawTenantBankAccount.bankName ?? '',
          currencyCode: rawTenantBankAccount.currency,
          iban: rawTenantBankAccount.iban,
          swiftBic: rawTenantBankAccount.swift,
          isPrimary: rawTenantBankAccount.isPrimary ?? false,
        }
      : null;

    return {
      paymentMethod: data.paymentMethod ?? null,
      dueDate: data.dueDate ?? null,
      cashRegisterId: data.cashRegisterId ?? null,
      customerBankAccountId: data.customerBankAccountId ?? null,
      tenantBankAccount: tenantBankAccount ?? null,
      amount: data.amount?.toString() ?? null,
      comment: comment ?? null,
      exchangeRate: exchangeRate ?? null,
      supplierInvoiceNumber: data.supplierInvoiceNumber ?? null,
      dateOfTaxableSupply: data.dateOfTaxableSupply ?? null,
      createCashRegisterDocument: data.createCashRegisterDocument ?? false,
    };
  };

  return [getPaymentBody] as const;
};
